module.exports = __webpack_public_path__ + "img/3.d90d6f46.jpg";